<script setup lang="ts">
// Shared site footer for every layout. Extracted from layouts/default.vue and
// layouts/full-width.vue (the two copies had diverged: default listed Pricing +
// Facebook, full-width didn't). This is the union of both.

const footerMenu = [
  { name: 'Partners', to: '/partners' },
  { name: 'Pricing', to: '/pricing' },
  { name: 'Contact', to: '/contact' },
  { name: 'Legal', to: '/legal' },
  { name: 'Privacy', to: '/privacy' },
  { name: 'Terms', to: '/terms' },
] as Array<{ name: string, to: string }>

const appStores = [
  { icon: 'mdi-google-play', label: 'Google Play', href: 'https://play.google.com/store/apps/details?id=com.adagger.sailingmetrics' },
  { icon: 'mdi-apple', label: 'App Store', href: 'https://apps.apple.com/app/sailingmetrics/id6761767585' },
  { icon: 'mdi-instagram', label: 'Instagram', href: 'https://www.instagram.com/sailingmetrics/' },
  { icon: 'mdi-facebook', label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61593998001472' },
] as Array<{ icon: string, label: string, href: string }>
</script>

<template>
  <v-footer padless>
    <v-row no-gutters>
      <v-col cols="12" md="6" class="py-10 text-center">
        <v-btn
            v-for="link in footerMenu"
            :key="link.to"
            variant="text"
            nuxt
            :to="link.to"
        >
          {{ link.name }}
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" class="py-10 text-center">
        <v-btn
            v-for="store in appStores"
            :key="store.href"
            :href="store.href"
            :icon="store.icon"
            :aria-label="store.label"
            target="_blank"
            rel="noopener"
            variant="plain"
            class="mx-4"
        />
      </v-col>
      <v-col cols="12" class="pb-15 text-center">
        {{ new Date().getFullYear() }} — <strong>SailingMetrics.com</strong>
      </v-col>
    </v-row>
  </v-footer>

  <v-footer bottom padless fixed>
    <CookieControl id="cookieControl" locale="en" />
  </v-footer>
</template>
